{
	"backLinkTitle": "Retour à la gestion des déclarations"
}
